import { createFileRoute } from "@tanstack/react-router";
import { BAA_URL, TERMS_MARKDOWN } from "@alm/domain/legal";
import { marketingHead } from "@/lib/marketing/seo";
import { breadcrumbs, webPageOf } from "@/lib/marketing/ppl-schema";
import { MLink } from "@/lib/marketing/m-link";
import { MarketingShell } from "@/components/marketing/site/marketing-shell";
import { LegalDocument } from "@/components/marketing/site/legal/legal-document";
import { LegalPrintButton } from "@/components/marketing/site/legal/legal-print-button";
import { siteLink } from "@/components/marketing/site/legal/legal-site-link";

export const Route = createFileRoute("/v2/terms")({
  component: TermsPage,
  head: () => {
    const seo = {
      title: "Terms of Service | PEOPLE AI Workforce",
      description:
        "The PPL AI Terms of Service: the contract a senior living operator accepts at checkout, with the Service Level Terms and the Business Associate Agreement.",
      path: "/v2/terms",
      imageAlt: "PEOPLE AI Workforce",
    };
    return marketingHead({
      ...seo,
      schema: [webPageOf(seo), breadcrumbs({ name: "Terms of Service", path: "/terms" })],
    });
  },
});

function TermsPage() {
  return (
    <MarketingShell>
      <article className="legal-document mx-auto max-w-3xl px-6 py-16 sm:py-24">
        <div className="mb-8 flex justify-end">
          <LegalPrintButton testId="button-print-terms" />
        </div>
        <LegalDocument
          markdown={TERMS_MARKDOWN}
          link={siteLink}
          linkBaa
          notes={{
            "appendix-b": (
              <p className="text-sm text-muted-foreground" data-testid="text-baa-standalone">
                Also published as a standalone page at{" "}
                <MLink href={BAA_URL} className="text-primary underline underline-offset-4">
                  /baa
                </MLink>
                ; the two texts are identical.
              </p>
            ),
          }}
        />
      </article>
    </MarketingShell>
  );
}
